import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";
// import jwtDecode  from 'jwt-decode';
//arrumar aqui
export default Object.assign(
    {
        apiUrl: "",

        async resendWelcomeEmail({ id }) {
            const url = this.url(`/welcome-email/resend/${id}`);
            return Vue.http.get(url);
        },

        async sendPerformanceEmail({ id }) {
            const url = this.userUrl(`/monthly-report/${id}`);
            return Vue.http.get(url);
        },

        async getPasswordRecoveryLink({ id }) {
            const url = this.url(`/password-recovery/link/${id}`);
            return Vue.http.get(url);
        },

        async getMasterPasswordRecoveryLink({ id }) {
            const url = this.url(`/master/password-recovery/link/${id}`);
            return Vue.http.get(url);
        },

        async login(data) {
            EventBus.$emit("SHOW_SPINNER");

            const login = await Vue.http
                .post(this.url("/login"), data)
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return login;
        },

        async user() {
            return Vue.http.get(this.url("/user"));
        },

        async loginAs({ id }) {
            return Vue.http.get(this.url(`/login/as/${id}`));
        },

        async getAuthenticatedWhitelabel() {
            return Vue.http.get(this.url("/whitelabel/authenticated"), {
                skipErrorHandling: true,
                timeout: 3000,
            });
        },

        async getPublicWhitelabel({ key } = {}) {
            return Vue.http.get(this.url("/whitelabel"), {
                params: key ? { key } : undefined,
                skipErrorHandling: true,
                timeout: 3000,
            });
        },
        async goBackToken() {
            return Vue.http.get(this.url(`/login/goBack/`));
        },

        async unlockLogin({ id }) {
            const url = this.userUrl({ path: `/unblock/${id}` });

            return Vue.http.put(url);
        },

        async forgotPassword(data) {
            const url = this.url("/forgot-password");

            console.log(url);

            return Vue.http.post(url, data);
        },

        async permissions() {
            return Vue.http.get(this.userUrl({ path: "/permissions" }));
        },
    },
    base
);
